import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const getTerminalPaymentSession = (terminalId, sessionId, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).get(`/terminals/${terminalId}/paymentSessions/${sessionId}`)
}

export default getTerminalPaymentSession
